/**
 * @since 2023-07-31
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

import ButtonBlue from "components/Shared/ButtonBlue";
import Report from "components/Shared/Report";
import TextError from "components/Shared/TextError";
import TextWait from "components/Shared/TextWait";
import {
  createImportedAnalysis,
  getStatusImportedAnalysis,
  loadImportedPreview,
  waitForImportedAnalysis,
} from "dataHandling/imported";
import { useEffect, useState } from "react";

const PreviewChart = ({ email, importedSettings }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [status, setStatus] = useState("");
  const [previewData, setPreviewData] = useState();

  useEffect(() => {
    fetchData();
  }, [importedSettings, email]);

  const fetchData = async () => {
    setIsLoading(true);
    const importedId = importedSettings.Settings.ImportedId;
    let newStatus = await getStatusImportedAnalysis(email, importedId);
    if (newStatus === "WAITING") {
      setStatus(newStatus);
      newStatus = await waitForImportedAnalysis(email, importedId);
    }
    if (newStatus === "OK") {
      const newPreviewData = await loadImportedPreview(email, importedId);
      setPreviewData(newPreviewData);
    }
    setStatus(newStatus);
    setIsLoading(false);
  };

  const handleCreateAnalysis = async () => {
    setStatus("WAITING");
    const importedId = importedSettings.Settings.ImportedId;
    await createImportedAnalysis(email, importedId);
    fetchData();
  };

  return (
    <>
      {status === "WAITING" && <TextWait />}
      {status === "ERROR" && (
        <>
          <TextError
            error={
              "Something went wrong, we are working on it. Please try again later."
            }
          />
          <ButtonBlue
            label="CREATE PREVIEW"
            alignment="left"
            height="34px"
            onClick={handleCreateAnalysis}
          />
        </>
      )}
      {status === "NEW" && (
        <ButtonBlue
          label="CREATE PREVIEW"
          alignment="left"
          height="34px"
          onClick={handleCreateAnalysis}
        />
      )}
      {status === "OK" && (
        <>
          <Report
            email={email}
            moduleType={"IMPORTED"}
            moduleId={importedSettings.Settings.ImportedId}
            reportData={previewData}
          />
          <ButtonBlue
            label="REFRESH PREVIEW"
            alignment="left"
            height="34px"
            onClick={handleCreateAnalysis}
          />
        </>
      )}
    </>
  );
};

export default PreviewChart;
